import PropTypes from "prop-types";
import React, { useState } from "react";
import { getAboutus, getCompany } from "../../Services/API/Get";
import LoadingSpinner from "../../components/LoadingSpinner/loadingSpinner";

const SectionTitleWithText = ({ spaceTopClass, spaceBottomClass }) => {

  const [company, setcompany] = useState("");
  const [about, setabout] = useState("");
  const [lopen, setlopen] = useState(false);

  const CompanyGet = () => {
    setlopen(true);
    getCompany()
      .then((res) => {
        setlopen(false);
        console.log(res.data);
        setcompany(res.data[res.data.length - 1]);
        // setLogo(res.data[res.data.length - 1].image)
        // this.setState({
        //   logo: res.data[res.data.length - 1].image,
        // });
      })
      .catch((error) => {
        setlopen(false);
        console.error(error);
      });
  };

  const AboutGet = () => {
    setlopen(true);
    getAboutus()
      .then((res) => {
        setlopen(false);
        console.log("about>>", res.data);
        setabout(res.data[res.data.length - 1]);
        // setLogo(res.data[res.data.length - 1].image)
        // this.setState({
        //   logo: res.data[res.data.length - 1].image,
        // });
      })
      .catch((error) => {
        setlopen(false);
        console.error(error);
      });
  };

  React.useEffect(() => {
    CompanyGet();
    AboutGet();

  }, []);

  return (
    <>
      <LoadingSpinner open={lopen} />
      <div
        className={`welcome-area ${spaceTopClass ? spaceTopClass : ""} ${spaceBottomClass ? spaceBottomClass : ""
          }`}
      >


        <div className="welcome-content text-left">
          <div className="container">
            <div className="row">
              <div className="welcome-content text-left">
                {/* <h5>Who Are We</h5> */}
                <h1>{`FLOOR SCRUBBER SERVICE AND REPAIRS`}</h1>
              </div>

              <div className="row">
                <div className="col-lg-9 col-md-9">
                  <p>
                  With a dedicated team of service technicians who will go the extra mile for our customers.
                   We are Melbourne’s leading floor Scrubber specialists.
                  </p>
                  <p>
                  Wherever you are located in Melbourne, we offer completely affordable tailored and flexible service
                   options that ensures that your commercial Floor Scrubber continues to operate in peak condition.
                  </p>
                  <p>

                  We provide premium quality onsite service to hotels, hospitals, institutions, retail and many other commercial sectors.
                  </p>
                  <p>
                  Oz Rentals delivers preventative maintenance service programs and professional repairs for many well-known brands of Floor Scrubbers.
                  </p>


                </div>
                <div className="col-lg-3 col-md-3">

                  <div
                    className={`single-banner`}
                  >


                    <img src={process.env.PUBLIC_URL + "/assets/img/services/img-1.jpg"} alt="" />


                  </div>


                </div>


              </div>




            </div>


          </div>

          <div className="container">
            <div className="row">
              <div className="welcome-content text-left">
                {/* <h5>Who Are We</h5> */}
                <h1>{`Get Your Floor Scrubber Working to it’s optimum`}</h1>
              </div>

              <div className="row">
                <div className="col-lg-9 col-md-9">
                  <p>
                  With quick service turnaround times, our professional service technicians will repair your floor scrubber back to life again with it’s optimum.
                  </p>
                  <p>
                  All of our floor scrubbers are only handled by our professional service technicians who have extensive hands-on experience in repairing all brands scrubbers.
                  </p>
                  <p>

                  Our process starts with a comprehensive check of all of the main working parts of your scrubber including a battery check.
                  </p>
                  <p>
                  We repair or replace only the part / part’s that are required to ensure equipment is working at optimum levels to ensure that you achieve the results you need.
                  </p>
                  <p>
                  With a strong local reputation for outstanding customer service, we take great pride in our service and repairs all work is guaranteed for three (3) months on parts.
                  </p>
                  <p>
                  We are confident that you’ll love our level of service and workmanship in helping your floor scrubber back to Its optimum performance.
                  </p>
                  <p>
                  Brands we service and repair but are not limited to include Tennant, Nilfisk, Alto, Clark Equipment, Hako just to name a few.
                  </p>


                </div>
                <div className="col-lg-3 col-md-3">

                  <div
                    className={`single-banner`}
                  >


                    <img src={process.env.PUBLIC_URL + "/assets/img/services/img-2.jpg"} style={{width:"300px", height:"300px"}}  alt="" />


                  </div>


                </div>


              </div>




            </div>


          </div>

        </div>


      </div>
    </>
  );
};

SectionTitleWithText.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default SectionTitleWithText;
